document.addEventListener('DOMContentLoaded', function () {
  // Same key/shape as cart-reviews.js.liquid's copy — written by cruise-photobook-builder-mount.js, pruned in both
  // places since the cart can be reached via either surface. See that file's comment for why it's projectId-keyed.
  const CART_PROJECT_DATES_KEY = 'cruisePhotobookCartProjectDates';
  function pruneStaleCartProjectDates(liveProjectUuids) {
    let stored;
    try {
      stored = JSON.parse(window.localStorage.getItem(CART_PROJECT_DATES_KEY) || '{}') || {};
    } catch (e) {
      return;
    }
    const liveSet = new Set(liveProjectUuids);
    let changed = false;
    Object.keys(stored).forEach(function (projectId) {
      if (!liveSet.has(projectId)) {
        delete stored[projectId];
        changed = true;
      }
    });
    if (changed) {
      try {
        window.localStorage.setItem(CART_PROJECT_DATES_KEY, JSON.stringify(stored));
      } catch (e) {
        // ignore
      }
    }
  }

  // Fills in (or hides) the badge container main-cart-items.liquid renders per photobook line — the date only
  // exists in localStorage, so this can't be done server-side. Re-run after every re-render (see subscribe below)
  // since <cart-items> replaces its own DOM with a fresh, hidden-by-default copy on every cartUpdate. Text
  // formatting/placeholder substitution lives in the shared assets/photobook-saved-badge.js (settings-driven
  // template + retention window, docs/printbox/architecture.md §8d) — this file only owns finding the DOM and
  // reading localStorage.
  function applyPhotobookSavedBadges() {
    let stored;
    try {
      stored = JSON.parse(window.localStorage.getItem(CART_PROJECT_DATES_KEY) || '{}') || {};
    } catch (e) {
      return;
    }
    document.querySelectorAll('[data-pbx-saved-badge]').forEach(function (el) {
      const projectId = el.dataset.pbxProjectUuid;
      const savedAt = projectId && stored[projectId];
      if (!savedAt || !window.CruisePhotobookSavedBadge) {
        el.style.display = 'none';
        return;
      }
      const textEl = el.querySelector('.product-info-panel__text');
      if (textEl) textEl.textContent = window.CruisePhotobookSavedBadge.buildText(savedAt);
      el.style.display = '';
    });
  }

  // Native /cart page has no UpCart events — mirrors cart-reviews.js.liquid's enforcePhotobookAddonLinks() via Dawn's own cartUpdate pubsub instead.
  function syncPhotobookAddonQuantities() {
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        const mainItemsByProject = {};
        cart.items.forEach(function (item) {
          const uuid = item.properties && item.properties['_pbx_project_uuid'];
          if (uuid && !(item.properties && item.properties['_pbx_addon'])) {
            mainItemsByProject[uuid] = item;
          }
        });

        pruneStaleCartProjectDates(Object.keys(mainItemsByProject));

        const updates = [];
        cart.items.forEach(function (item) {
          if (!item.properties || item.properties['_pbx_addon'] !== 'true') return;
          const uuid = item.properties['_pbx_project_uuid'];
          const mainItem = uuid && mainItemsByProject[uuid];
          const perUnit = parseInt(item.properties['_pbx_additional_pages_per_unit'], 10) || 0;
          const targetQuantity = mainItem ? perUnit * mainItem.quantity : 0;
          if (targetQuantity === item.quantity) return;

          updates.push(fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: targetQuantity })
          }));
        });

        if (updates.length) {
          Promise.all(updates).then(function () {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pbx-addon-sync' });
          });
        }
      });
  }

  // Initial page load — no cartUpdate event fires for this, <cart-items>' own server-rendered badges are already
  // in the DOM (just hidden) by the time this script runs.
  applyPhotobookSavedBadges();

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    // syncPhotobookAddonQuantities() republishes its own cartUpdate (source: 'pbx-addon-sync') once the addon
    // line's quantity is adjusted — skipped here to avoid re-triggering itself, but <cart-items> still re-renders
    // its DOM a *second* time in response to that republished event, wiping out whatever applyPhotobookSavedBadges()
    // just filled in from the first pass. Real bug hit live: changing the main line's quantity correctly resynced
    // the addon quantity but silently dropped the saved-date badge, because only the first cartUpdate ever
    // rescheduled a badge reapply. Badges are idempotent to reapply, so just always reschedule them, regardless
    // of which cartUpdate this is — only the addon-quantity sync itself needs the self-sourced guard.
    if (!event || event.source !== 'pbx-addon-sync') {
      syncPhotobookAddonQuantities();
    }
    // <cart-items> re-renders its own DOM asynchronously on this same event — same margin as elsewhere in this
    // codebase for "wait for the re-render before touching the DOM it produced" (cart-reviews.js.liquid uses
    // setTimeout(…, 1000) for the same reason on the UpCart side).
    setTimeout(applyPhotobookSavedBadges, 500);
  });
});
